import axiosInstance from '@core/api/axios-config';
import { API_ENDPOINTS } from '@core/api/api-endpoints';

export interface SiteSettings {
    id: string;
    logoUrl: string;
    headerLinks: Array<{ label: string; href: string }>;
    footerLinks: {
        shopOnline: Array<{ label: string; href: string }>;
        information: Array<{ label: string; href: string }>;
    };
    contactEmail?: string;
    contactPhone?: string;
    address?: string;
    socialLinks: Array<{ platform: string; url: string; icon: string }>;
    footerCopyright?: string;
    aboutText?: string;
    featuredBrandSlot1Id?: string | null;
    featuredBrandSlot2Id?: string | null;
    updatedAt: string;
}

export const siteSettingsApi = {
    getSettings: async (): Promise<SiteSettings> => {
        const response = await axiosInstance.get(API_ENDPOINTS.SITE_SETTINGS.BASE);
        return response.data;
    },

    updateSettings: async (settings: Partial<SiteSettings>): Promise<SiteSettings> => {
        // Strip fields that aren't in the backend DTO
        const { id, updatedAt, ...rest } = settings as any;
        // Convert JSON fields back to strings for the backend
        const payload = {
            ...rest,
            headerLinks: rest.headerLinks ? JSON.stringify(rest.headerLinks) : undefined,
            footerLinks: rest.footerLinks ? JSON.stringify(rest.footerLinks) : undefined,
            socialLinks: rest.socialLinks ? JSON.stringify(rest.socialLinks) : undefined,
        };
        const response = await axiosInstance.put(API_ENDPOINTS.SITE_SETTINGS.BASE, payload);
        return response.data;
    },

    uploadLogo: async (file: File): Promise<string> => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await axiosInstance.post(`${API_ENDPOINTS.FILES.UPLOAD}/settings`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data.imageUrl;
    },
};
